import { fetchEndpoint } from '../server/network'

// 获取红包列表 ECMobile 4.0
export const cashgiftList = (data) => fetchEndpoint('/v2/ecapi.cashgift.list', 'POST', data)

// 获取可用的红包列表 ECMobile 4.0
export const cashgiftAvailable = (data) => fetchEndpoint('/v2/ecapi.cashgift.available', 'POST', data)

// 订单可用红包列表
export const bonusList = (data) => fetchEndpoint('/v2/ecapi.bonus.List', 'POST', data)

//验证红包码
export const codeBonus = (data) => fetchEndpoint('/v2/ecapi.code.bonus', 'POST', data)


// WEBPACK FOOTER //
// ./src/api/cashgift.js